export const common = {
  nav: {
    home: 'Accueil',
    about: 'À propos',
    rooms: 'Chambres',
    gallery: 'Galerie',
    reservation: 'Réservation',
    access: 'Accès',
    contact: 'Contact',
    forOwners: 'Pour les propriétaires',
    freeConsultation: 'Consultation gratuite',
  },
  hero: {
    title: 'Là où la tradition rencontre',
    subtitle: 'le confort moderne',
    description: 'Découvrez le charme authentique d\'une maison japonaise traditionnelle à Magome, Ota-ku, Tokyo. Un mélange parfait de beauté historique et de commodités contemporaines.',
    bookNow: 'Réserver maintenant',
    viewGallery: 'Voir la galerie',
  },
  about: {
    title: 'À propos',
    subtitle: 'Une harmonie entre l\'architecture japonaise traditionnelle et le confort moderne',
    description: 'La Maison Traditionnelle de Magome est une maison japonaise magnifiquement restaurée, située dans le quartier résidentiel calme de Magome, Ota-ku, Tokyo. Soigneusement rénovée pour préserver son charme traditionnel tout en offrant des équipements modernes, elle offre une opportunité unique de vivre une expérience japonaise authentique.',
    feature1Title: 'Maison entière',
    feature1Desc: 'Profitez d\'une intimité totale avec votre famille et vos amis dans cette location exclusive',
    feature2Title: 'Cuisine complète',
    feature2Desc: 'Cuisine entièrement équipée pour préparer vos plats préférés',
    feature3Title: 'Jusqu\'à 8 personnes',
    feature3Desc: 'Hébergement spacieux, idéal pour les groupes et les familles',
    feature4Title: 'Tatami traditionnel',
    feature4Desc: 'Chambres japonaises authentiques avec tatamis et chaleur du bois',
  },
  rooms: {
    title: 'Chambres',
    subtitle: 'Détendez-vous dans des espaces japonais traditionnels',
    room1: 'Plan d\'étage',
    room2: 'Cuisine complète',
    room3: 'Lit simple',
    capacity: 'Capacité maximale',
    guests: '8 personnes',
    amenities: 'Équipements',
    amenitiesList: 'Cuisine complète, Réfrigérateur, Micro-ondes, Ustensiles de cuisine, Vaisselle, Wi-Fi, Climatisation, Chauffage, Machine à laver, Salle de bain, Toilettes, Serviettes, Articles de toilette',
  },
  gallery: {
    title: 'Galerie',
    subtitle: 'Découvrez la beauté de la Maison Traditionnelle de Magome',
  },
  reservation: {
    title: 'Réservation',
    subtitle: 'Réservez votre séjour exceptionnel',
    name: 'Nom complet',
    email: 'Adresse e-mail',
    phone: 'Numéro de téléphone',
    checkin: 'Arrivée',
    checkout: 'Départ',
    guests: 'Nombre de personnes',
    message: 'Demandes spéciales',
    submit: 'Envoyer la demande',
    submitting: 'Envoi en cours...',
    success: 'Votre demande de réservation a été reçue. Nous vous contacterons sous peu.',
    error: 'Échec de l\'envoi. Veuillez réessayer.',
    bookingPlatforms: 'Vous pouvez également réserver via ces plateformes',
    bookOnAirbnb: 'Vérifier les disponibilités et réserver sur Airbnb',
    bookOnJalan: 'Vérifier les disponibilités et réserver sur Jalan',
    orDirectBooking: 'ou contactez-nous directement',
    required: 'Requis',
    guestsPlaceholder: '― Sélectionner ―',
    guestSingular: 'Personne',
    guestPlural: 'Personnes',
    messagePlaceholder: 'Des demandes spéciales ou des questions ? N\'hésitez pas. (max 500 caractères)',
    confirmNote: '※ Nous vous contacterons après confirmation de votre demande.',
  },
  contact: {
    title: 'Contact',
    subtitle: 'N\'hésitez pas à nous contacter pour toute question',
    name: 'Nom complet',
    email: 'Adresse e-mail',
    subject: 'Sujet',
    message: 'Message',
    submit: 'Envoyer',
    submitting: 'Envoi en cours...',
    success: 'Votre message a été reçu. Nous vous contacterons sous peu.',
    error: 'Échec de l\'envoi. Veuillez réessayer.',
    address: 'Adresse',
    addressDetail: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    access: 'Accès',
    accessDetail: '8 minutes à pied de la gare de Magome (Ligne Toei Asakusa)',
    faqBannerTitle: 'Avant d\'envoyer, consultez notre FAQ',
    faqBannerDesc: 'Nous avons déjà répondu à de nombreuses questions sur les tarifs, les procédures et la gestion.',
    faqBannerBtn: 'Voir la FAQ',
    accessInfoTitle: 'Informations d\'accès',
    sendMessageTitle: 'Envoyer un message',
    inquiryType: 'Type de demande',
    inquiryTypePlaceholder: 'Sélectionnez le type de demande',
    inquiryOptions: {
      minpaku: 'Enregistrement Minpaku / Demande de permis',
      ryokan: 'Obtention de licence Ryokan',
      management: 'Gestion immobilière / Opérations',
      pricing: 'Tarifs / Plans',
      marketing: 'Annonce Airbnb / Marketing',
      revenue: 'Simulation de revenus',
      other: 'Autre',
    },
    messagePlaceholder: 'Décrivez votre demande (max 500 caractères)',
    detailLabel: 'Détails de la consultation',
    detailPlaceholder: 'Décrivez l\'emplacement, la situation actuelle et vos souhaits (max 500 caractères)',
  },
  access: {
    label: 'Accès',
    title: 'Accès & Carte',
    subtitle: 'Situé dans le quartier résidentiel calme de Higashi-Magome, Ota-ku, Tokyo',
    addressLabel: 'Adresse',
    addressLine1: '1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    addressLine2: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    trainLabel: 'En train',
    trainLine1: '2 min à pied de la gare de Magome (Ligne Toei Asakusa)',
    trainLine2: '',
    busLabel: 'En bus',
    busLine1: '2 min à pied de l\'arrêt de bus "Magome Ekimae" (Bus Toei)',
    busLine2: '',
    parkingLabel: 'Parking',
    parkingLine1: 'Parkings payants disponibles à proximité',
    parkingLine2: 'Veuillez nous contacter si vous venez en voiture',
    openMap: 'Ouvrir dans Google Maps',
  },
  footer: {
    description: 'Location d\'une maison japonaise traditionnelle à Magome, Ota-ku, Tokyo. Vivez l\'harmonie parfaite entre la beauté japonaise et le confort moderne.',
    quickLinks: 'Liens rapides',
    followUs: 'Suivez-nous',
    rights: 'Tous droits réservés.',
    napTitle: 'Cabinet Yokota — Fiscalité & Comptabilité',
    napAddress: '1-12-12 Higashi-Magome, Ota City, Tokyo',
    napAddressJa: '東京都大田区東馬込1-12-12',
    napPhone: 'Tél. : Veuillez nous contacter',
    napServiceArea: 'Zone de service : Ota City et Grand Tokyo',
    napAccess: 'Ligne Toei Asakusa — Gare de Magome',
  },
  stickyButton: {
    title: 'Consultation',
    subtitle: 'gratuite 30 min',
  },
  ownersBanner: {
    subtitle: 'Pour les propriétaires envisageant Airbnb à Tokyo',
    linkText: 'En savoir plus sur nos services de soutien aux propriétaires →',
  },
  airbnbLead: {
    title: 'Vous pensez à lancer Airbnb à Tokyo ?',
    description: 'Nous offrons un accompagnement complet — de l\'enregistrement minpaku et l\'obtention de la licence ryokan à la gestion complète de la propriété. Basés à Ota City avec une véritable expérience opérationnelle.',
    ctaButton: 'Obtenir une consultation gratuite',
    badge1: 'Consultation sans engagement',
    badge2: 'Expérience opérationnelle réelle',
    badge3: 'Support complet de la licence à la gestion',
  },
  trust: {
    badge: 'Pourquoi nous choisir',
    title: 'La confiance des propriétaires de Tokyo',
    subtitle: 'Nous combinons une expérience opérationnelle réelle et un soutien complet pour vous aider à réussir.',
    point1Title: 'Expérience Airbnb réelle',
    point1Description: 'Nous gérons activement notre propre hébergement traditionnel à Ota City. Nos conseils sont basés sur une expérience concrète, pas sur la théorie.',
    point2Title: 'Support complet pour les licences',
    point2Description: 'De l\'enregistrement minpaku à l\'obtention de la licence ryokan — nous gérons toute la paperasse et les communications avec les autorités.',
    point3Title: 'Optimisation des revenus',
    point3Description: 'Stratégies de tarification basées sur les données réelles du marché de Tokyo. Augmentation moyenne des revenus de plus de 30% pour nos clients.',
    point4Title: 'Support client 24h/24',
    point4Description: 'Communication multilingue avec les clients 24h/24 pour que vous puissiez vous concentrer sur vos revenus.',
    point5Title: 'Rapports transparents',
    point5Description: 'Rapports de revenus mensuels et structures de frais claires. Pas de coûts cachés, pas de surprises.',
    ctaButton: 'Découvrir nos services',
  },
  howItWorks: {
    title: 'Comment ça marche',
    subtitle: 'Un processus simple et transparent, de la consultation au lancement réussi',
    step1Number: '01',
    step1Title: 'Consultation gratuite',
    step1Desc: 'Partagez les détails de votre propriété et vos objectifs. Nous vous donnons des conseils honnêtes sur les licences, le potentiel de revenus et les prochaines étapes.',
    step2Number: '02',
    step2Title: 'Évaluation de la propriété',
    step2Desc: 'Nous évaluons l\'adéquation de votre propriété, identifions les exigences et créons un plan d\'action personnalisé.',
    step3Number: '03',
    step3Title: 'Lancement & Support',
    step3Desc: 'De la demande de licence à la gestion des clients, nous gérons tout pour que vous puissiez vous concentrer sur vos revenus.',
    ctaButton: 'Réserver votre consultation gratuite',
    ctaNote: '30 minutes • Sans engagement • Feuille de route claire',
  },
  urgency: {
    title: 'Vous pensez à lancer Airbnb à Tokyo ?',
    description: 'Les règles de licence sont complexes et les erreurs peuvent retarder votre lancement. Obtenez des conseils clairs et pratiques avant de prendre des décisions.',
    ctaButton: 'Réserver une consultation gratuite',
    note: 'Consultation de 30 minutes • Sans engagement • Expérience réelle',
  },
  trustRisk: {
    title: 'Consultation sans pression',
    description: 'Nous fournissons des conseils pratiques basés sur une expérience réelle. Même si vous décidez de ne pas continuer, vous recevrez une feuille de route claire.',
    badge1Title: 'Sans engagement',
    badge1Desc: 'Conseils gratuits sans pression',
    badge2Title: 'Expérience réelle',
    badge2Desc: 'Nous gérons notre propre propriété',
    badge3Title: 'Feuille de route claire',
    badge3Desc: 'Conseils pratiques que vous pouvez utiliser',
    whatYouGetTitle: 'Ce que vous obtiendrez de notre consultation',
    item1: 'Évaluation honnête du potentiel de votre propriété',
    item2: 'Explication claire des exigences de licence et du calendrier',
    item3: 'Projections de revenus réalistes basées sur votre emplacement',
    item4: 'Feuille de route étape par étape que vous pouvez suivre indépendamment',
    ctaButton: 'Planifier votre consultation gratuite',
    ctaNote: 'Disponible lundi–vendredi, 9h00–18h00 JST',
  },
  faq: {
    title: 'Questions fréquentes',
    subtitle: 'Questions courantes sur le démarrage et l\'exploitation d\'Airbnb et de Minpaku à Tokyo',
    ctaText: 'Vous avez d\'autres questions ? Nous sommes là pour vous aider.',
    ctaButton: 'Réserver une consultation gratuite',
    q1: 'Comment démarrer Airbnb à Tokyo ?',
    a1: 'Démarrer un Airbnb à Tokyo nécessite l\'obtention d\'une licence appropriée. Vous avez deux options principales : l\'enregistrement Minpaku (hébergement résidentiel) ou la licence Ryokan (hébergement simple). Le Minpaku permet jusqu\'à 180 jours d\'exploitation par an et nécessite un enregistrement auprès des autorités locales. La licence Ryokan permet une exploitation toute l\'année mais nécessite de satisfaire à des normes d\'installation plus strictes et à des réglementations de sécurité incendie.',
    q2: 'Quelle est la différence entre Minpaku et la licence Ryokan ?',
    a2: 'Le Minpaku (民泊) est un enregistrement d\'hébergement résidentiel qui permet aux propriétaires de louer leur maison jusqu\'à 180 jours par an. Il a des exigences plus simples mais des limitations opérationnelles. Le Ryokan (簡易宿所) est une licence d\'hébergement simple qui permet une exploitation toute l\'année sans limite de jours. Cependant, il nécessite de satisfaire à des normes d\'installation plus strictes, des équipements de sécurité incendie et des inspections régulières.',
    q3: 'Les étrangers peuvent-ils démarrer Airbnb au Japon ?',
    a3: 'Oui, les étrangers peuvent démarrer des activités Airbnb au Japon, mais il y a des exigences importantes. Vous devez avoir un statut de résidence approprié permettant des activités commerciales au Japon. La propriété ou un contrat de bail valide est requis, et vous devez désigner un représentant de gestion résidant au Japon et pouvant répondre aux problèmes dans les 30 minutes.',
    q4: 'Combien de temps prend l\'enregistrement Minpaku à Tokyo ?',
    a4: 'L\'enregistrement Minpaku à Tokyo prend généralement 2 à 4 mois de la préparation initiale à l\'approbation. Le calendrier comprend : évaluation et préparation de la propriété (2–3 semaines), préparation des documents et inspection de sécurité incendie (2–4 semaines), soumission au gouvernement local (1–2 semaines de traitement), et approbation finale et enregistrement (1–2 semaines).',
    q5: 'Combien coûte le démarrage ?',
    a5: 'Les coûts varient en fonction de la portée des services et de l\'état de votre propriété. Nous proposons des plans incluant le soutien à la demande, la préparation des documents et l\'évaluation sur site. Pour les services de gestion immobilière, nous utilisons une structure de frais basée sur la performance — un pourcentage des revenus — afin que vous puissiez démarrer avec des coûts initiaux minimaux.',
    q6: 'Que pouvez-vous gérer si je trouve l\'autogestion difficile ?',
    a6: 'Nous pouvons tout gérer — gestion des réservations, communication avec les clients, coordination du nettoyage, remise des clés, résolution des problèmes et rapports de revenus mensuels. Les propriétaires peuvent essentiellement gérer un Airbnb sans intervention.',
    q7: 'Puis-je gérer Airbnb dans un appartement en copropriété ?',
    a7: 'Gérer Airbnb dans un appartement en copropriété est possible tant que cela n\'est pas interdit par les règles de gestion du bâtiment. Vous devez d\'abord vérifier les règlements de gestion pour confirmer qu\'il n\'y a pas de clauses interdisant les activités d\'hébergement ou de location à court terme.',
    q8: 'Je suis préoccupé par les plaintes des voisins. Comment gérez-vous cela ?',
    a8: 'Nous établissons des règles de maison claires pour les clients (bruit, élimination des déchets, utilisation des espaces communs, etc.) et les expliquons soigneusement à l\'arrivée pour prévenir les problèmes. Si une plainte survient, nous avons un système de réponse 24h/24 pour évaluer et traiter rapidement la situation.',
    q9: 'Quels revenus puis-je espérer ?',
    a9: 'Les revenus varient considérablement en fonction de l\'emplacement, de la taille, des équipements et du taux d\'occupation de la propriété. Dans les zones populaires de Tokyo, les propriétés de 1LDK à 2LDK peuvent générer des revenus mensuels de 200 000 à 500 000 ¥ dans certains cas. Nous proposons une simulation de revenus gratuite basée sur nos données opérationnelles passées.',
    q10: 'Est-il possible de simplement consulter ? Serai-je pressé de signer un contrat ?',
    a10: 'Absolument — les consultations seules sont les bienvenues. Nous ne vous pressons jamais de signer un contrat sur place. Nous espérons que vous prendrez votre temps et prendrez une décision à votre propre rythme.',
  },
  seo: {
    home: {
      title: 'Magome Kominka | Maison Japonaise Traditionnelle Tokyo & Gestion Airbnb',
      description: 'Séjournez dans une maison japonaise traditionnelle à Magome, Ota-ku, Tokyo — location entière jusqu\'à 8 personnes. Gestion Airbnb professionnelle et support licence minpaku par des hôtes actifs.',
      keywords: 'Magome Kominka, Tokyo Airbnb, Ota City minpaku, maison japonaise traditionnelle, location courte durée Tokyo',
    },
    management: {
      title: 'Service de Gestion Airbnb Tokyo | Location Courte Durée Complète',
      description: 'Gestion Airbnb professionnelle à Tokyo. Communication clients, tarification dynamique, coordination nettoyage et rapports mensuels. Gestion complète pour propriétaires à Ota City et grand Tokyo.',
      keywords: 'gestion Airbnb Tokyo, location courte durée Tokyo, gestion immobilière Ota City, service client Tokyo',
    },
    support: {
      title: 'Support Minpaku & Licence Ryokan Tokyo | Lancement Activité d\'Hébergement',
      description: 'Support expert pour l\'enregistrement minpaku et la demande de licence ryokan à Tokyo. Accompagnement pratique par des hôtes actifs à Ota City — des démarches administratives au lancement.',
      keywords: 'enregistrement minpaku Tokyo, licence ryokan Tokyo, support Airbnb Tokyo, location courte durée Ota City',
    },
    forOwners: {
      title: 'Gestion Airbnb Tokyo & Support Licence Minpaku pour Propriétaires',
      description: 'Gestion Airbnb complète et support licence minpaku pour propriétaires à Tokyo. De la licence aux opérations quotidiennes et nettoyage — support complet par des opérateurs expérimentés. Consultation gratuite.',
      keywords: 'propriétaires Airbnb Tokyo, support licence minpaku, gestion immobilière Tokyo, Airbnb Ota City',
    },
    pricing: {
      title: 'Tarifs Gestion Airbnb Tokyo | Plans Transparents pour Propriétaires',
      description: 'Tarification claire et transparente pour la gestion Airbnb et le support minpaku à Tokyo. Support lancement, configuration complète, service de gestion et forfaits nettoyage. Sans frais cachés.',
      keywords: 'tarifs gestion Airbnb Tokyo, coût support minpaku, plans location courte durée Tokyo, frais gestion Tokyo',
    },
    minpakuRegistration: {
      title: 'Enregistrement Minpaku Tokyo | Guide Étape par Étape Licence Ryokan',
      description: 'Guide complet pour l\'enregistrement minpaku à Tokyo. Processus de demande de licence ryokan, documents requis, calendrier et erreurs courantes — basé sur l\'expérience réelle à Ota City.',
      keywords: 'enregistrement minpaku Tokyo, licence ryokan Tokyo, support Airbnb Tokyo, location courte durée Ota City',
    },
    guide: {
      title: 'Guide Démarrage Minpaku Tokyo 2026 | Licence, Revenus & Gestion',
      description: 'Guide complet pour lancer votre activité Airbnb à Tokyo. Minpaku vs Ryokan, étapes de licence, calendrier, erreurs courantes, estimation des revenus et quand utiliser un service de gestion.',
      keywords: 'guide minpaku Tokyo, démarrer Airbnb Tokyo, licence minpaku, licence ryokan, location courte durée Tokyo',
    },
    caseStudy: {
      title: 'Étude de Cas Lancement Minpaku Ota City | Succès Airbnb Tokyo',
      description: 'Étude de cas réelle : propriétaire à Ota City a lancé Airbnb en 3,5 mois avec licence Ryokan, atteignant ¥180 000+/mois et 78% d\'occupation. Découvrez le support minpaku Tokyo en action.',
      keywords: 'Ota City minpaku, étude de cas Airbnb Tokyo, licence ryokan Tokyo, gestion Airbnb Tokyo',
    },
    adsLanding: {
      title: 'Lancez Votre Activité Airbnb Légale à Tokyo | Support Licence Minpaku & Ryokan',
      description: 'Support professionnel licence minpaku et ryokan à Tokyo. Gestion Airbnb complète par des hôtes actifs à Ota City. Consultation gratuite 30 min. Support lancement à partir de ¥300 000.',
      keywords: 'Airbnb légal Tokyo, support licence minpaku, demande ryokan Tokyo, lancement Airbnb Ota City',
    },
    airbnbGuide: {
      title: 'Guide Légal Airbnb Tokyo | Guide Complet Licence Minpaku & Ryokan',
      description: 'Guide complet pour démarrer légalement Airbnb à Tokyo. Enregistrement minpaku, exigences licence ryokan, coûts, calendrier et procédure étape par étape — basé sur l\'expérience réelle à Ota City.',
      keywords: 'licence Airbnb Tokyo, enregistrement minpaku Tokyo, licence ryokan Tokyo, gestion Airbnb Tokyo, location courte durée Ota City',
    },
  },
  schema: {
    management: {
      offerDescription: '15 % à 20 % du chiffre d\'affaires mensuel',
      service1: 'Ajustement des prix & tarification dynamique',
      service2: 'Communication avec les clients (multilingue)',
      service3: 'Gestion des avis',
      service4: 'Coordination nettoyage & linge',
      service5: 'Rapport de revenus mensuel',
      service6: 'Programme d\'aide à la déclaration fiscale',
    },
  },
  taxOffice: {
    badge: 'Cabinet Comptable & Fiscal',
    sectionTitle: 'Cabinet Yokota — Fiscalité & Comptabilité',
    sectionSubtitle: 'Expert en fiscalité minpaku à Higashi-Magome, Ota City, Tokyo',
    businessName: 'Cabinet Yokota — Fiscalité & Comptabilité',
    businessNameEn: 'Yokota Tax & Accounting Office',
    addressLabel: 'Adresse',
    addressJa: '東京都大田区東馬込1-12-12',
    addressEn: '1-12-12 Higashi-Magome, Ota City, Tokyo, Japan',
    serviceAreaLabel: 'Zone de service',
    serviceArea: 'Ota City et Grand Tokyo',
    serviceAreaEn: 'Ota City and Greater Tokyo',
    accessLabel: 'Accès',
    accessJa: 'Ligne Toei Asakusa — Gare de Magome',
    accessEn: 'Toei Asakusa Line — Magome Station',
    openMapBtn: 'Ouvrir dans Google Maps',
    supportTitle: 'Support fiscal Minpaku & Airbnb',
    supportItems: [
      'Système d\'aide à la déclaration fiscale (pas de représentation fiscale)',
      'Support fiscal minpaku à Ota City',
      'Consultation fiscale Airbnb Tokyo',
      'Support fiscal minpaku Tokyo — première consultation gratuite',
      'Consultation fiscale Airbnb Tokyo — aide à la déclaration de revenus',
    ],
    disclaimer: '※ "Système d\'aide à la déclaration fiscale" désigne l\'assistance à la préparation des documents et les conseils. Cela ne constitue pas une représentation fiscale.',
    officeImageAlt: 'Cabinet Yokota — Bureau comptable à Higashi-Magome, Ota City',
    officeImageCaption: 'Cabinet Yokota — Higashi-Magome, Ota City, Tokyo',
    officeImageSubCaption: 'Support fiscal minpaku Ota City · Consultation fiscale Airbnb Tokyo',
  },
  managementContact: {
    title: 'Formulaire de consultation gratuite',
    name: 'Nom complet',
    nameRequired: 'Requis',
    phone: 'Numéro de téléphone',
    email: 'Adresse e-mail',
    emailRequired: 'Requis',
    propertyType: 'Type de bien',
    propertyTypePlaceholder: 'Veuillez sélectionner',
    propertyTypeOptions: {
      mansion1k: 'Appartement（Studio–1LDK）',
      mansion2ldk: 'Appartement（2LDK+）',
      house: 'Maison individuelle',
      kominka: 'Maison traditionnelle',
      taxConsult: 'Consultation fiscale',
      other: 'Autre',
    },
    consultContent: 'Détails de la consultation',
    consultContentRequired: 'Requis',
    consultContentCounter: '{{count}}/500 car.',
    consultContentPlaceholder: 'Décrivez l\'emplacement, la situation actuelle et vos souhaits（max 500 caractères）',
    submit: 'Demander une consultation gratuite',
    submitting: 'Envoi en cours...',
    success: 'Merci pour votre demande. Nous vous contacterons dans les 2 jours ouvrables.',
    error: 'Échec de l\'envoi. Veuillez réessayer.',
    beforeContact: 'Avant de nous contacter',
    infoItems: [
      'Première consultation entièrement gratuite',
      'Principalement dans la région de Tokyo',
      'Réponse sous 2 jours ouvrables',
      'Vos données personnelles sont strictement protégées',
    ],
    recommendTitle: 'Nous vous recommandons de consulter si…',
    recommendItems: [
      'Vous avez un bien mais ne pouvez pas le gérer',
      'Vous souhaitez démarrer un Minpaku en activité secondaire',
      'Vous n\'êtes pas satisfait de vos revenus actuels',
      'Vous cherchez un service de nettoyage',
      'Vous ne savez pas comment utiliser Airbnb',
    ],
    confirmNote: 'Après confirmation, notre équipe vous contactera.',
  },
  privateDriver: {
    badge: 'Service Partenaire',
    title: 'Chauffeur Privé',
    titleEn: 'Private Driver Service',
    description: 'Nos chauffeurs partenaires offrent un transport professionnel — des transferts aéroport aux visites touristiques.',
    descriptionHighlight: 'Chauffeurs anglophones disponibles.',
    featureTitle: 'Pourquoi choisir notre service',
    features: [
      { title: 'Chauffeurs anglophones', desc: 'Chauffeurs professionnels anglophones pour les clients internationaux.' },
      { title: 'Sûr & Assuré', desc: 'Chauffeurs professionnels entièrement assurés pour un voyage sûr et confortable.' },
      { title: 'Disponible 24h/24', desc: 'Vols tôt le matin ou arrivées tardives — nous sommes toujours prêts sur réservation.' },
      { title: 'Grands bagages OK', desc: 'Grands véhicules disponibles pour les familles. Plusieurs valises, aucun problème.' },
      { title: 'Itinéraires personnalisés', desc: 'Itinéraires spéciaux vers les spots rétro Showa et lieux de tournage sur demande.' },
    ],
    menuTitle: 'Menu des services',
    priceGuide: 'Guide tarifaire',
    pricingTitle: 'Guide tarifaire',
    pricingNote: 'Tous les prix incluent les taxes. Estimations uniquement — contactez-nous pour des devis précis.',
    discountBadge: 'Remise exclusive',
    discountTitle: 'Réservé aux clients',
    discountOff: '10% DE RÉDUCTION',
    discountSuffix: 'Remise spéciale',
    discountNote: 'Mentionnez votre séjour lors de la réservation pour bénéficier de la remise.',
    discountBtn: 'Réserver maintenant',
    ctaBadge: 'Exclusif pour les clients KOMINKA',
    ctaTitle: 'Tarifs spéciaux pour les clients',
    ctaDesc: 'Les clients KOMINKA bénéficient de remises exclusives sur notre service de chauffeur privé.',
    ctaBtn: 'Réserver un chauffeur',
    officialPartner: 'Official Partner',
    officialPartnerJa: '提携サービス',
    services: [
      { title: 'Transfert aéroport', subtitle: '空港送迎', desc: 'Prise en charge & dépose aéroport Haneda/Narita. Service d\'accueil disponible.', price: 'À partir de ¥8 000' },
      { title: 'Visite de Tokyo', subtitle: '東京観光ドライブ', desc: 'Explorez les quartiers Showa, temples et trésors cachés avec un chauffeur local.', price: 'À partir de ¥15 000/3h' },
      { title: 'Support long séjour', subtitle: '長期滞在サポート', desc: 'Service de chauffeur hebdomadaire ou mensuel pour courses et excursions.', price: 'À partir de ¥40 000/semaine' },
      { title: 'Transport lieux de tournage', subtitle: '撮影ロケ送迎', desc: 'Transport vers les spots Showa emblématiques et lieux de tournage.', price: 'À partir de ¥12 000/2h' },
    ],
    pricing: [
      { title: 'Transfert aéroport', subtitle: 'Airport Transfer', rows: [{ label: 'Aéroport Haneda ⇔ Magome (aller simple)', price: '¥8 000+' }, { label: 'Aéroport Narita ⇔ Magome (aller simple)', price: '¥14 000+' }, { label: 'Supplément nuit (22h–6h)', price: '+¥2 000' }, { label: 'Grands bagages (3+ valises)', price: '+¥1 000' }], note: '* Même prix jusqu\'à 4 passagers' },
      { title: 'Visite de Tokyo', subtitle: 'Tokyo City Tour', rows: [{ label: 'Circuit 3 heures', price: '¥15 000+' }, { label: 'Circuit 5 heures', price: '¥22 000+' }, { label: 'Journée complète (8 heures)', price: '¥35 000+' }, { label: 'Circuit spécial Showa Rétro', price: '+¥3 000' }], note: '* Guide & parking inclus' },
      { title: 'Transport lieux de tournage', subtitle: 'Photo Location Drive', rows: [{ label: 'Circuit 2 heures', price: '¥12 000+' }, { label: 'Circuit 4 heures', price: '¥20 000+' }, { label: 'Option guide de lieux', price: '+¥2 000' }, { label: 'Équipement/grands bagages', price: '+¥1 500' }], note: '* Consultation d\'itinéraire possible à l\'avance' },
      { title: 'Support long séjour', subtitle: 'Long Stay Support', rows: [{ label: 'Une fois par semaine (4x/mois)', price: '¥40 000+' }, { label: 'Deux fois par semaine (8x/mois)', price: '¥72 000+' }, { label: 'Utilisation unique (3 heures)', price: '¥12 000+' }, { label: 'Courses/hôpital', price: '¥6 000+/trajet' }], note: '* 10% de réduction avec paiement mensuel' },
    ],
  },
};

export default common;
